<div #tableContainer class="table-container">
  <aur-mat-table
    [tableConfig]="tableConfig()"
    [tableData]="drivers()"
    [expandedRow]="expandedDriver()"
    [highlightedRow]="highlightedDriver()"
    (highlightedRowChange)="onHighlightedDriverChange($event)"
    (rowAction)="onRowAction($event)"
    (rowClick)="onRowClick($event)">
    <ng-template ngxAurCellDef="unit" let-unitName let-driver="rowSrc">
      <span class="driver-link-cell">
        <mat-icon>{{ unitIcon(driver) }}</mat-icon>
        <span>{{ unitName }}</span>
      </span>
    </ng-template>

    @if (canEdit()) {
      <ng-template ngxAurExpandedRowDef let-row="row">
        @let driver = asDriver(row);
        <div class="detail-info">
          <div class="content">
            @if (!isListMode() && !driver.unit) {
              <span>
                {{
                  'driver.assign-to-unit'
                    | translate: {
                      driverName: driver.getFullName(),
                      unitName: lastSelectedUnitName(),
                    }
                }}
              </span>
            }
            @if (!isListMode() && driver.unit) {
              <span>
                {{
                  'driver.remove-assign'
                    | translate: {
                      driverName: driver.getFullName(),
                      oldUnitName: driver.unit.name,
                      newUnitName: lastSelectedUnitName(),
                    }
                }}
              </span>
            }
            @if (isListMode()) {
              <span>
                {{ 'driver.delete' | translate: {driverName: driver.getFullName()} }}
              </span>
            }
          </div>

          <div class="action-buttons">
            <button mat-button class="button" (click)="cancel()">
              {{ 'action.cancel' | translate }}
            </button>
            @if (!isListMode()) {
              <button mat-button class="button major" (click)="assign(driver)">
                {{ 'action.assign' | translate }}
              </button>
            }
            @if (isListMode()) {
              <button mat-button class="button delete" (click)="delete(driver)">
                {{ 'action.delete' | translate }}
              </button>
            }
          </div>
        </div>
      </ng-template>
    }
  </aur-mat-table>
</div>
